import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

import { checkExist } from '@/apis/index'

Vue.config.productionTip = false

import './assets/main.less'

import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'

import 'weui'
import weui from 'weui.js'
import VueWechatTitle from 'vue-wechat-title'
Vue.use(VueWechatTitle)
Vue.prototype.$weui = weui

Vue.use(ElementUI)

import axios from 'axios'
Vue.prototype.$axios = axios
import { DETAIL_DATASETCODE_MAP } from '@/utils/staticData'
import { Message } from 'element-ui'
/* 保存文件 */
import { saveAs } from 'file-saver'
import './utils/passDataAcrossWindows'
Vue.prototype.$saveAs = saveAs

import { getDate } from '@/utils/tools'
Vue.prototype.$getDate = getDate

import VueScrollactive from 'vue-scrollactive'

Vue.use(VueScrollactive)

//引入swiper样式
import 'swiper/css/swiper.css'

/* 跳转详情页公用方法 */
function goDetail({ _id, data_type, id, dataType }) {
  let myId = _id || id
  let myDataType = data_type || dataType
  let userInfo = sessionStorage.getItem('userInfo') ? JSON.parse(sessionStorage.getItem('userInfo')) : {}
  let right = userInfo.datasetRightInfo?.[myDataType]?.detailRight
  if (right == 1) {
    let detailObj = DETAIL_DATASETCODE_MAP[myDataType]
    let path = detailObj.path

    let resolve = router.resolve(path + `?id=${myId}`)
    window.open(resolve.href, '_blank')
  } else {
    Message({
      message: '无页面访问权限',
      type: 'warning',
    })
  }
}
//判断是否有下载权限
function checkRights({ data_type, dataType }) {
  let myDataType = data_type || dataType
  let userInfo = sessionStorage.getItem('userInfo') ? JSON.parse(sessionStorage.getItem('userInfo')) : {}
  let right = userInfo.datasetRightInfo?.[myDataType]?.fileDownloadRight
  if (right === 0) {
    Message({
      message: '无页面访问权限',
      type: 'warning',
    })
    return false
  }
  return true
}

Vue.prototype.$goDetail = goDetail
Vue.prototype.$checkRights = checkRights

Vue.prototype.$checkTypeValidator = async (checkType, getTrue = true, value, callBack) => {
  let tip = ''
  switch (checkType) {
    case 1:
      tip = '用户名'
      break
    case 2:
      tip = '手机号'
      break
    case 3:
      tip = '邮箱'
      break

    default:
      break
  }
  let res = await checkExist({ checkType, param: value })
  let isExist = res.data
  if (getTrue) {
    //校验存在时抛出错误
    isExist ? callBack(new Error(`当前${tip}已存在`)) : callBack()
  } else {
    //不存在时抛出错误
    !isExist ? callBack(new Error(`当前${tip}不存在`)) : callBack()
  }
}

//定义全局统计图数据来源名称
Vue.prototype.$dataSourceName = '全球智库发现系统'

import lazyLoad from 'vue-lazyload'
Vue.use(lazyLoad, {
  loading: require('./assets/loading.gif'), //加载成功图片
  error: require('./assets/error.png'), //加载失败图片
  try: 2, //加载图片数量
})

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount('#app')
